"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

// Definiujemy, że dataLayer istnieje w obiekcie window
declare global {
  interface Window {
    dataLayer: any[];
  }
}

export function GtmPageviewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      const url = pathname + searchParams.toString();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "virtual_page_view",
        page_path: url,
      });
    }
  }, [pathname, searchParams]);

  return null; // Ten komponent niczego nie renderuje na ekranie
}
